import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import imageVodafone from "../../..//assets/images/New_VF_Icon_RGB_RED.svg"
import imageNIQS from "../../../public/img/niqs.svg"
import imagePoweredByVisonum from "../../../public/img/powered-by-visonum.svg"
import Tabs from "../../components/expertMode/Tabs";
import expertModeSlice from "../../features/expertMode/expertModeSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { ExpertModeTheme } from "../../theme/expert-mode";
import RealtimeTab from "./ExpertModePage/RealtimeTab";
import StatisticTab from "./ExpertModePage/StatisticsTab";

const Root = styled.div<Props>(() =>
    css`
        padding: 40px;
    `)

const Body = styled.div(() =>
    css`
        padding-right: 40%;
    `)

const VodafoneLogo = styled.img(
    css`
        width: 25px;
        height: 25px;
        margin-right: 15px;
    `)

const NIQSLogo = styled.img(
    css`
        width: 100%;
    `)

const VisonumLogo = styled.img(
    css`
        width: 100%;
    `)

const Header = styled.div(
    css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding-top: 30px;
        margin-bottom: 20px;
        font-style: normal;
        font-weight: 700;
        font-size: 30px;
        line-height: 45px;
    `)

const BrandBox = styled.div<Props>(
    props => css`
        background-color: ${props.expertTheme.colors.secondary};
        width: 160px;
        height: 130px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        justify-content: space-between;
    `)

const Title = styled.div(css``)

type Props = {
    expertTheme: ExpertModeTheme
}

const ExpertModePage: FC<Props> = props => {
    const state = useAppSelector(state => state);
    const dispatch = useAppDispatch();

    return (
        <Root {...props}>
            <Header {...props}>
                <Title {...props}>
                    <VodafoneLogo {...props} src={imageVodafone.src} />
                    Speedtest Plus Admin View
                </Title>
                <BrandBox {...props}>
                    <NIQSLogo {...props} src={imageNIQS.src} />
                    <VisonumLogo {...props} src={imagePoweredByVisonum.src} />
                </BrandBox>
            </Header>
            <Tabs<"realtime" | "statistic"> {...props}
                tabs={[
                    {
                        id: "realtime",
                        label: "Realtime",
                        content: <RealtimeTab {...props} />
                    },
                    {
                        id: "statistic",
                        label: "Statistik",
                        content: <StatisticTab {...props}/>
                    }
                ]}
                selectedTabId={state.expertMode.selectedTab}
                onSelect={(id) => dispatch(
                    expertModeSlice.actions.selectTab(id)
                )}
            />
        </Root>
    )
}

export default ExpertModePage